import { render, staticRenderFns } from "./ManageMediaBlock.vue?vue&type=template&id=543bdbe2&scoped=true&"
import script from "./ManageMediaBlock.vue?vue&type=script&lang=js&"
export * from "./ManageMediaBlock.vue?vue&type=script&lang=js&"
import style0 from "./ManageMediaBlock.vue?vue&type=style&index=0&id=543bdbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543bdbe2",
  null
  
)

export default component.exports